
import json from '#shared/util/json.js';
import appError from '#shared/util/appError.js';
import logger from '#shared/util/logger.js';
import readArguments from '#shared/util/readArguments.js';

import asyncCall from './asyncCall.js';

/**
 * IPM retargeting toaster
 */
export default {

	/**
	 * Set retargeting URL
	 * @param {object} options
	 * @param {string} [options.brand] avast / avg
	 * @param {string} options.url retargeting url
	 * @param {Array} [options.timeouts] @todo remove timeouts when deprecated in client and IPM
	 * @returns {Promise}
	 */
	set({ brand = 'avast', url, timeouts = [3600000, 82800000] } = {}) {
		const isTimeoutsValid = Array.isArray(timeouts) && timeouts.every((current) => {
			return Number.isFinite(current);
		});
		if (typeof url === 'string' && typeof brand === 'string' && isTimeoutsValid) {
			const opmCall = `${brand}.opm.set_event`;
			return new Promise((resolve) => {

				asyncCall('SetRetargetedToaster', () => { }, [url, timeouts.map((timeout) => {
					return timeout / 60000;
				}).join(', ')]); // @todo remove when deprecated in client and IPM

				asyncCall(opmCall, ([, error]) => {
					if (error) {
						logger.warn({
							code: 'CLIENT',
							origin: opmCall,
							detail: json.parse(error) || {}
						});
					} else {
						resolve();
					}
				}, {
					version: 1,
					id: 'CALL_RETARGET_TOASTER',
					ipm_values: [{
						p_url: url
					}]
				});
			});
		} else {
			throw appError('Invalid method arguments to retargetingToaster.set', {
				code: 'APP_FRONTEND_UTIL',
				origin: 'retargetingToaster.set',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	},

	/**
	 * Unset retargeting URL
	 * @param {object} options
	 * @param {string} [options.brand] avast / avg
	 * @returns {Promise}
	 */
	unset({ brand = 'avast' } = {}) {
		if (typeof brand === 'string') {
			const opmCall = `${brand}.opm.dismiss_event`;
			return new Promise((resolve) => {

				asyncCall('SetRetargetedToaster', () => { }, []); // @todo remove when deprecated in client and IPM

				asyncCall(opmCall, ([, error]) => {
					if (error) {
						logger.warn({
							code: 'CLIENT',
							origin: opmCall,
							detail: json.parse(error) || {} // @todo update detail structure
						});
					} else {
						resolve();
					}
				}, {
					version: 1,
					id: 'CALL_RETARGET_TOASTER'
				});
			});
		} else {
			throw appError('Invalid method arguments to retargetingToaster.unset', {
				code: 'APP_FRONTEND_UTIL',
				origin: 'retargetingToaster.unset',
				detail: readArguments(arguments) // @todo update detail structure
			});
		}
	}
};
